import { AwsAnalyticProvider } from './provider/aws/aws-analytic-provider';
import getUserAgentAttributes from './user-agent-attributes';
import { trimAttribute } from './utils';
let analyticProvider;
let additionalAttributes = {};
function setAdditionalAttributes(setAttributes) {
  const currentAttributes = additionalAttributes;
  additionalAttributes = setAttributes(currentAttributes);
}
function clearAdditionalAttributes() {
  additionalAttributes = {};
}
function getAdditionalAttributes() {
  return Object.entries(additionalAttributes).reduce((attributes, [key, attribute]) => {
    attributes[key] = attribute instanceof Function ? attribute() : attribute; // eslint-disable-line no-param-reassign
    return attributes;
  }, {});
}
function record(args) {
  const {
    name,
    attributes,
    metrics
  } = args;
  const systemAttributes = {};
  const systemAttributesRaw = {
    ...getUserAgentAttributes(),
    ...getAdditionalAttributes(),
    url: window.location.href
  };
  Object.entries(systemAttributesRaw).forEach(([key, value]) => {
    systemAttributes[key] = value ? trimAttribute(value) : value;
  });
  return analyticProvider.record({
    name,
    attributes: {
      ...systemAttributes,
      ...attributes
    },
    metrics
    // immediate: true,
  });
}
async function updateEndpoint(args) {
  return analyticProvider.updateEndpoint({
    ...args
  });
}
function enablePageViewAutoTracking(applicationType = 'SPA') {
  analyticProvider.autoTrack('pageView', {
    enable: true,
    type: applicationType,
    attributes: {
      ...getUserAgentAttributes(),
      ...getAdditionalAttributes()
    }
  });
}
export async function getAnalytics() {
  return {
    record,
    updateEndpoint,
    setAdditionalAttributes,
    clearAdditionalAttributes
  };
}
export function configure({
  configuration,
  provider
}) {
  const {
    cognito,
    pinpoint
  } = configuration;
  if (provider === 'AWS') {
    analyticProvider = new AwsAnalyticProvider(cognito, pinpoint);
  }
  if (analyticProvider) {
    enablePageViewAutoTracking(pinpoint.applicationType);
  }
}